<kendo-window title="Erreur applicative" *ngIf="opened" (close)="close()" [minWidth]="250" [width]="650">
    <p>Message : {{erreur.message}}</p>
    <div *ngIf="erreur.stackTrace">
        <p>Stack trace :</p>
        <div *ngFor="let stackFrame of erreur.stackTrace;">
            {{stackFrame.toString()}}
        </div>
    </div>
</kendo-window>